import '../home.css';
import BottomNav from '../components/BottomNav';

function Home() {
  const name = JSON.parse(localStorage.getItem('user'))?.name || 'Гість';

  return (
    <div className="home-container">
      <h2 className="home-title">Привіт, {name}!</h2>
      <BottomNav />
    </div>
  );
}

export default Home;